(function ($, utils) { 
    $(function() {
        const debounce = function (tm, fn) {
            let timer 
            let _time = 0
            return (...args) => {
                let timeLeft = Math.max(tm - (Date.now() - _time), 0)
                clearTimeout(timer)
                timer = setTimeout(() => fn.apply(this, args), timeLeft)
                _time = timeLeft === 0 ? Date.now() : _time;
            }
        }

        let scrolled = false;
        $(window).on("scroll", debounce(100, function () {
            const currentScrolled = $(window).scrollTop() >= 1;
            if (scrolled === currentScrolled) return;
            scrolled = currentScrolled
            if (scrolled) {
                utils.styles.addClass({ selectors: '.watch-scroll', cssClasses: 'scrolled' })
            } else {
                utils.styles.removeClass({ selectors: '.watch-scroll', cssClasses: 'scrolled' })
            }
        }))
    })
})(jQuery, app.utils)
